import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, switchMap, take } from 'rxjs/operators';
import { BlogPostGetModel } from 'src/app/interfaces/interfaces';
import { BlogPostLogicService } from 'src/app/logic/blog-post.service';
import { DashboardLogicService } from 'src/app/logic/dashboard.service';
import { PassDataService } from 'src/app/services/pass-data.service';

@Component({
  selector: 'app-blog-post-list',
  templateUrl: './blog-post-list.component.html',
  styleUrls: ['./blog-post-list.component.scss']
})
export class BlogPostListComponent implements OnInit {

  postsList$: Observable<BlogPostGetModel[]> = new Observable<
  BlogPostGetModel[]
  >();

  deletePostId: string = '';

  page: number = 1;

  constructor(
    private passDataService: PassDataService,
    private blogPostLogic: BlogPostLogicService,
    private dashboardLogicService: DashboardLogicService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.postsList$ = this.passDataService.getAllBlogPosts();
  }

  onAddButtonClick() {
    this.router.navigate(['/page/add-blog-post'], {
      state: { isAdd: true, isEdit: true, isView: false },
    });
  }

  receivedAction(e: any) {
    e.isAddSloka &&
      this.router.navigate(['/page/add-blog-post/'], {
        state: {
          isAddSloka: true,
          isAdd: true,
          isEdit: true,
          isView: false,
          data: e.data,
        },
      });

    e.isEdit &&
      this.router.navigate([`/page/blog-post/${e.data.title}`], {
        state: {
          isAddSloka: false,
          isAdd: false,
          isEdit: true,
          isView: false,
          data: e.data,
        },
      });

    e.isView &&
      this.router.navigate([`/page/blog-post/${e.data.title}`], {
        state: {
          isAddSloka: false,
          isAdd: false,
          isEdit: false,
          isView: true,
          data: e.data,
        },
      });

    e.isDelete &&
      this.passDataService.setPopup({
        isPopup: true,
        message: 'Are you sure to delete this blog post?',
        isOk: false,
        isDelete: true,
        response: '',
      });

    e.isDelete &&
      this.passDataService
        .getPopupAction()
        .pipe(
          filter((a) => {
            return (a != '' || a != null || typeof a != 'undefined');
          }),
          map((b) => b == 'delete'),
          filter((c) => c),
          switchMap(async (d) => {
            //console.log(d)
            return await this.blogPostLogic.deleteBlogPostLogic(e?.data)
        }
          ),
          take(1)
        )
        .subscribe((v: any) => {
          //console.log(v)
          v.message == 'Blog Post deleted succesfully' &&
            this.dashboardLogicService.getAllSlokaTypesAndSlokas().subscribe() &&
            this.passDataService.setPopup({
              isPopup: true,
              message: 'Blog post deleted successfully!',
              isOk: true,
              isDelete: false,
              response: '',
            });
        });
  }

}
